import { SolvedProblemsPresenter } from '@/presentation/presenters/dashboard/solvedProblemsPresenter'
import { StatisticsViewModel } from '@/presentation/viewmodels/dashboard/statisticsViewModel'

export function useSolvedProblemsPresenter(
  presenter: SolvedProblemsPresenter = new SolvedProblemsPresenter(new StatisticsViewModel())
) {
  return {
    isLoading: presenter.isLoading,
    error: presenter.error,
    chartData: presenter.chartData,
    chartSeries: presenter.chartSeries,
    chartOptions: presenter.chartOptions,
    hasData: presenter.hasData,
    initChart: presenter.initChart.bind(presenter)
  }
}
